import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  background: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    aspectRatio: "16 / 9",
  },
  background2: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    aspectRatio: "1 / 1",
  },
  img: {
    maxWidth: "100%",
    objectFit: "contain",
  },
  noFile: {
    padding: 8,
  },
  iconClear: {
    position: "absolute",
    top: "2px",
    right: "2px",
    color: "#ffff",
  },
}));

export default useStyles;
